import React from 'react'
import ReactDOM from 'react-dom/client'
// import { ClerkProvider } from '@clerk/clerk-react'
// Import QueryClient and QueryClientProvider directly from @tanstack/react-query
// The virtual module will ensure these exports work correctly
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'

// Validate QueryClient is available
if (!QueryClient || typeof QueryClient !== 'function') {
  const error = new Error(`QueryClient is ${QueryClient === undefined ? 'undefined' : typeof QueryClient}. Expected function.`)
  console.error('QueryClient validation failed:', error.message, { QueryClient })
  throw error
}
if (!QueryClientProvider || typeof QueryClientProvider !== 'function') {
  const error = new Error(`QueryClientProvider is ${QueryClientProvider === undefined ? 'undefined' : typeof QueryClientProvider}. Expected function.`)
  console.error('QueryClientProvider validation failed:', error.message, { QueryClientProvider })
  throw error
}

let qc
try {
  qc = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 1
      }
    }
  })
  console.log('QueryClient instance created successfully:', qc)
} catch (error) {
  console.error('Failed to create QueryClient:', error)
  throw error
}

// const clerkPk = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// if (!clerkPk) {
//   throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable')
// }

// Error boundary component to catch rendering errors
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
          <h1>Something went wrong</h1>
          <p>{this.state.error?.message || 'Unknown error'}</p>
          <pre>{this.state.error?.stack}</pre>
        </div>
      )
    }

    return this.props.children
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={qc}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
